/**
 * Traduit les libellés des ingrédients courants selon la langue
 */

import { useState, useEffect } from "react";
import { translateTextAPI } from "../../../../utils/translationAPI";
import {
  commonIngredients,
  quickStartIngredients,
} from "../constants/ingredients.js";

export function useTranslatedLabels(language) {
  const [translatedLabels, setTranslatedLabels] = useState({});

  useEffect(() => {
    if (language === "fr") {
      setTranslatedLabels({});
      return;
    }
    const allToTranslate = [
      ...new Set([...commonIngredients, ...quickStartIngredients]),
    ];
    let cancelled = false;
    Promise.all(
      allToTranslate.map((ing) =>
        translateTextAPI(ing, language, "fr").then((tr) => [ing, tr]),
      ),
    ).then((pairs) => {
      if (cancelled) return;
      const map = {};
      pairs.forEach(([orig, trans]) => {
        map[orig] = trans || orig;
      });
      setTranslatedLabels(map);
    });
    return () => {
      cancelled = true;
    };
  }, [language]);

  const getIngredientLabel = (ingredient) =>
    translatedLabels[ingredient] ?? ingredient;
  return { translatedLabels, getIngredientLabel };
}
